/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessNotifications.internal

import features.userBusinessNotifications.models.UserBusinessNotificationsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessNotificationsRequest : NetworkRequest() {

    suspend fun getUserBusinessNotifications(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<UserBusinessNotificationsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessNotificationsEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
